import React from 'react';
import ExternalLink from '../ExternalLink';
import InstagramIcon from '../../assets/img/social_media_icons/white/instagram.svg';
import TiktokIcon from '../../assets/img/social_media_icons/white/tiktok.svg';
import FacebookIcon from '../../assets/img/social_media_icons/white/facebook.svg';
import XIcon from '../../assets/img/social_media_icons/white/x.svg';
import styles from './SocialMediaFooter.module.css';

function SocialMediaFooter() {
  return (
    <div className={styles.wrapper}>
      <ExternalLink
        aria-label="Go to our Instagram page"
        className={styles.iconLink}
        href="https://www.instagram.com/farmersfridge/"
      >
        <img alt="" src={InstagramIcon} />
      </ExternalLink>
      <ExternalLink
        aria-label="Go to our Tiktok page"
        className={styles.iconLink}
        href="https://www.tiktok.com/@farmersfridge"
      >
        <img alt="" src={TiktokIcon} />
      </ExternalLink>
      <ExternalLink
        aria-label="Go to our Facebook page"
        className={styles.iconLink}
        href="https://www.facebook.com/farmersfridge"
      >
        <img alt="" src={FacebookIcon} />
      </ExternalLink>
      <ExternalLink
        aria-label="Go to our X (formerly Twitter) page"
        className={styles.iconLink}
        href="https://twitter.com/FarmersFridge"
      >
        <img alt="" src={XIcon} />
      </ExternalLink>
    </div>
  );
}

export default SocialMediaFooter;
